/**
 *
 * Asynchronously loads the component for Crossbelt bombay Module
 *
 */

import loadable from "core/components/loadable";

export default loadable(() => import("./index"));
